module.exports = __webpack_public_path__ + "img/btm-blue-shape.91ae02b8.png";